/**
 * Service worker version to update the cache.
 */
export const SERVICE_WORKER_VERSION = 'wesog-cache-v2.6.1';
